import { 
  GET_ANALYTICS_STICKY_COLUMNS, 
  GET_ANALYTICS_STICKY_COLUMNS_ERROR, 
  GET_ANALYTICS_STICKY_COLUMNS_SUCCESS, 
  UPDATE_ANALYTICS_STICKY_COLUMNS, 
  UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR, 
  UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

export const getAnalyticsStickyColumns = () => {
  return {
    type: GET_ANALYTICS_STICKY_COLUMNS,
  }
}

export const getAnalyticsStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_ANALYTICS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getAnalyticsStickyColumnsError = error => {
  return {
    type: GET_ANALYTICS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateAnalyticsStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_ANALYTICS_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateAnalyticsStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateAnalyticsStickyColumnsError = error => {
  return {
    type: UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}